import * as z from 'zod';
import { StoredGameInfoSchema, } from '../firestore/gameInfo.js';
export { StoredGameInfoSchema as GameInfoSchema };
export const SetGameInfoSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('open'),
    }),
    z.object({
        action: z.literal('unlock'),
    }),
    z.object({ action: z.literal('lock'), locksIn: z.int().nonnegative() }),
]);
//# sourceMappingURL=gameInfo.js.map